// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img1 img{max-height:510px}.img1 img,.img2 img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.img2 img{max-height:224px}@media (min-width:1024px){.img2 img{max-height:384px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
